import { Buffergs925ekssbch as Buffer } from './Buffer.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
  add2suhfggl4zvkk as add,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkBoundsw7d8y6z7j2xc as checkBounds } from './-Util.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealSourceClass;
function RealSource() {
  if (RealSourceClass === VOID) {
    class $ {
      constructor(source) {
        this.x4g_1 = source;
        this.y4g_1 = false;
        this.z4g_1 = new (Buffer())();
      }
      a3y() {
        return this.z4g_1;
      }
      u4f(sink, byteCount) {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.y4g_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message_0 = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().s2(toString(message_0));
        }
        if (this.z4g_1.v2() === 0n) {
          var read = this.x4g_1.u4f(this.z4g_1, 8192n);
          if (read === -1n)
            return -1n;
        }
        // Inline function 'kotlin.comparisons.minOf' call
        var b = this.z4g_1.v2();
        var toRead = byteCount <= b ? byteCount : b;
        return this.z4g_1.u4f(sink, toRead);
      }
      b3y() {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.y4g_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        return this.z4g_1.b3y() && this.x4g_1.u4f(this.z4g_1, 8192n) === -1n;
      }
      c3y(byteCount) {
        if (!this.h3y(byteCount))
          throw EOFException().z4e("Source doesn't contain required number of bytes (" + byteCount.toString() + ').');
      }
      h3y(byteCount) {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.y4g_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message_0 = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().s2(toString(message_0));
        }
        while (this.z4g_1.v2() < byteCount) {
          if (this.x4g_1.u4f(this.z4g_1, 8192n) === -1n)
            return false;
        }
        return true;
      }
      k3y() {
        this.c3y(1n);
        return this.z4g_1.k3y();
      }
      s4f(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        if (this.z4g_1.v2() === 0n) {
          var read = this.x4g_1.u4f(this.z4g_1, 8192n);
          if (read === -1n)
            return -1;
        }
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.z4g_1.v2();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(tmp0);
        var tmp$ret$2 = a <= b ? a : b;
        var toRead = convertToInt(tmp$ret$2);
        return this.z4g_1.s4f(sink, startIndex, startIndex + toRead | 0);
      }
      w4f(sink, byteCount) {
        try {
          this.c3y(byteCount);
        } catch ($p) {
          if ($p instanceof EOFException()) {
            var e = $p;
            sink.v4f(this.z4g_1, this.z4g_1.v2());
            throw e;
          } else {
            throw $p;
          }
        }
        this.z4g_1.w4f(sink, byteCount);
      }
      x4f(sink) {
        var totalBytesWritten = 0n;
        while (!(this.x4g_1.u4f(this.z4g_1, 8192n) === -1n)) {
          var emitByteCount = this.z4g_1.q4f();
          if (emitByteCount > 0n) {
            totalBytesWritten = add(totalBytesWritten, emitByteCount);
            sink.v4f(this.z4g_1, emitByteCount);
          }
        }
        if (this.z4g_1.v2() > 0n) {
          totalBytesWritten = add(totalBytesWritten, this.z4g_1.v2());
          sink.v4f(this.z4g_1, this.z4g_1.v2());
        }
        return totalBytesWritten;
      }
      j4f() {
        this.c3y(2n);
        return this.z4g_1.j4f();
      }
      f40() {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.y4g_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        return buffered(new (PeekSource())(this));
      }
      q6() {
        if (this.y4g_1)
          return Unit_instance;
        this.y4g_1 = true;
        this.x4g_1.q6();
        this.z4g_1.f5();
      }
      toString() {
        return 'buffered(' + toString(this.x4g_1) + ')';
      }
    }
    initMetadataForClass($, 'RealSource', VOID, VOID, [Source()]);
    RealSourceClass = $;
  }
  return RealSourceClass;
}
//region block: exports
export {
  RealSource as RealSource1sojixeyllf40,
};
//endregion

//# sourceMappingURL=RealSource.mjs.map
